module.exports = __webpack_public_path__ + "img/homeimg06@2x_wps.8d81d177.png";